{
    "formRows": [
      {
        "formGroups": [
          {
            "style": {
              "gridColumn": "span 3"
            },
            "control": {
              "label": "lut",
              "displayLabel": "LUT",
              "skipLabel": true,
              "defaultValue": false,
              "fieldInfo": {
                "dataType": "boolean"
              }
            }
          },
          {
            "style": {
              "gridColumn": "span 3"
            },
            "control": {
              "label": "lutNo",
              "displayLabel": "LUT No",
              "placeHolder": "Enter LUT No",
              "fieldInfo": {
                "dataType": "text"
              },
              "conditions": {
                "visibility": {
                  "rules": [
                    { "field": "lut", "operator": "EQUALS", "value": true }
                  ]
                }
              },
              "validators": [
                {
                  "type": "required",
                  "message": "LUT No is required"
                }
              ]
            }
          },
          {
            "style": {
              "gridColumn": "span 3"
            },
            "control": {
                "label": "lutValidityDate",
                "displayLabel": "LUT Validity Date",
                "placeHolder": "Select LUT Validity Date",
                "fieldInfo": {
                    "dataType": "date"
                },
                "conditions": {
                  "visibility": {
                    "rules": [
                      { "field": "lut", "operator": "EQUALS", "value": true }
                    ]
                  }
                },
                "validators": [
                    {
                    "type": "required",
                    "message": "LUT Validity Date is required"
                    }
                ]
            }
          }
        ]
      }
    ]
}